/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';

// Component imports
import { Col, Row, Tooltip, Typography } from 'antd';

// Misc imports
import { truncate } from '../../../utils/string/truncate';
import { useFetchCSATSectionsQuery } from '../../../store/CSAT/CSATApi';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const SessionCSATTab = ({ chatSession }) => {

  const { t } = useTranslation();
  const { orgId } = useParams();

  // eslint-disable-next-line no-unused-vars
  const { data: csatSections } = useFetchCSATSectionsQuery({
    orgId,
    urlParams: {
      search: '',
      status: ''
    }
  },
  { selectFromResult: ({ data }) => {
    const itemsMap = new Map();

    data?.forEach(item => {
      itemsMap.set(item?.id, item);
    });

    return {
      data: itemsMap
    };
  } }
  );

  if (!chatSession) {
    return (
      <Text type="secondary">
        No session data available.
      </Text>
    );
  }

  return (
    <div className="overflow-y-auto pl-2 pr-2 overflow-x-hidden" style={{ maxHeight: 590 }}>
      <Row>
        <Text className={'fw-bold fs-lg'}>{t('CSAT')}</Text>
        <Col span={24} className="mt-3">
          {
            chatSession?.csatSurveys?.map((survey, index) => {
              return (
                <Row key={survey?.id} className="w-100 mb-3">
                  <Col xs={24} className="mb-1">
                    <Text className="text-muted">
                      {survey?.name || `${t('Survey')} ${index + 1}`}
                    </Text>
                  </Col>
                  <Col xs={24}>
                    {
                      survey?.sectionsScore ? (
                        <Fragment>
                          {
                            Object.entries(survey?.sectionsScore)?.map(([sectionId, score]) => {
                              const sectionTitle = csatSections?.get(sectionId)?.title || '-';
                              return (
                                <Fragment key={`${sectionId}_${survey.id}`}>
                                  <Row className="mb-0 ml-2">
                                    <Col span={11} className="text-left">
                                      <Tooltip
                                        title={sectionTitle.length >= 45 && sectionTitle}
                                      >
                                        <Text strong>{truncate(sectionTitle, 45, '...')} :</Text>
                                      </Tooltip>
                                    </Col>
                                    <Col span={13} className="text-left pl-2">
                                      <Text> {`${score}/5`}</Text>
                                    </Col>
                                  </Row>
                                </Fragment>
                              );
                            })
                          }
                          <Row className="mb-0 ml-2">
                            <Col span={11} className="text-left">

                              <Text strong>{survey.openEndedQuestionText || t('Open-ended question response')}:</Text>

                            </Col>
                            <Col span={13} className="text-left pl-2">
                              <Text> {survey.openEndedResponse}</Text>
                            </Col>
                          </Row>

                        </Fragment>
                      ) : (
                        <Row className="ml-2">
                          <Col span={24}>
                            <Text>{t(`CSAT not answered.`)}</Text>
                          </Col>
                        </Row>
                      )
                    }

                  </Col>
                </Row>
              );
            })
          }
        </Col>
      </Row>
    </div>
  );
};

SessionCSATTab.propTypes = {
  chatSession: PropTypes.array
};

export default SessionCSATTab;
